export default __webpack_public_path__ + "static/media/IMG-20250105-WA0015.cf90bd87.jpg";